import React from 'react'
import PropTypes from 'prop-types'
import { Field, propTypes, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import CardActions from '@material-ui/core/CardActions'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles, createStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { translate, userLogin } from 'ra-core'
import { envPreffix } from '../../utils'
import { push } from 'react-router-redux'

const styles = () => createStyles({
    form: {
        padding: '0 1em 1em 1em',
    },
    input: {
        marginTop: '1em',
    },
    button: {
        width: '100%',
    },
    button2: {
      width: '100%',
      fontSize: 10
    },
    title : {
        color : '#646567',
        textAlign : 'center',
        fontSize : 23
    },
    logo : {
        '& img' : {
            width : '100%',
            height : '100%',
        },
        padding: 20,
        boxSizing: 'border-box',
        height: 130
    }
})

// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({
    meta: { touched, error } = { touched: false, error: '' }, // eslint-disable-line react/prop-types
    input: { ...inputProps }, // eslint-disable-line react/prop-types
    ...props
}) => (
    <TextField
        error={!!(touched && error)}
        helperText={touched && error}
        {...inputProps}
        {...props}
        fullWidth
    />
)
const login = (auth, dispatch, { redirectTo }) =>
    dispatch(userLogin(auth, redirectTo))


const envTitle = envPreffix()

const LoginForm = ({ classes, isLoading, handleSubmit, translate, ...props }) => (
    <form onSubmit={handleSubmit(login)}>
        <div className={classes.form}>
            <div>
                <div className={classes.logo} >
                    <img src="/logo_coordinador.svg" alt={"logo coordinador eléctrico"} />
                </div>
                <Typography className={classes.title} variant={'title'}>
                    Activos de Transmisión {envTitle ? <strong style={{color: 'red'}}><br/>{envTitle}</strong> : ''}
                </Typography>
            </div>
            <div className={classes.input}>
                <Field
                    autoFocus
                    id="username"
                    name="username"
                    component={renderInput}
                    label={translate('ra.auth.username')}
                    disabled={isLoading}
                />
            </div>
            <div className={classes.input}>
                <Field
                    id="password"
                    name="password"
                    component={renderInput}
                    label={translate('ra.auth.password')}
                    type="password"
                    disabled={isLoading}
                />
            </div>
        </div>
        <CardActions>
            <Button
                variant="raised"
                type="submit"
                color="primary"
                disabled={isLoading}
                className={classes.button}
            >
                {isLoading && <CircularProgress size={25} thickness={2} />}
                {translate('ra.auth.sign_in')}
            </Button>
        </CardActions>
        <CardActions>
          <Button
            variant="raised"
            color="secondary"
            size="small"
            onClick={() => props.push('/forget_password')}
            className={classes.button2}
          >
            Olvidaste la Contraseña
          </Button>
        </CardActions>
    </form>
)
LoginForm.propTypes = {
    ...propTypes,
    classes: PropTypes.object,
    redirectTo: PropTypes.string,
}

const mapStateToProps = state => ({ isLoading: state.admin.loading > 0 })

const enhance = compose(
    withStyles(styles),
    translate,
    connect(mapStateToProps, { push }),
    reduxForm({
        form: 'signIn',
        validate: (values, props) => {
            const errors = {}
            const { translate } = props
            if (!values.username)
                errors.username = translate('ra.validation.required')
            if (!values.password)
                errors.password = translate('ra.validation.required')
            return errors
        },
    })
)

export default enhance(LoginForm)
